var CoordMap = /** @class */ (function () {
    function CoordMap() {
        var _this = this;
        this.getCoordKey = function (coord) {
            return coord.rowId + ":" + coord.columnId;
        };
        this.map = new Map();
        this.size = this.map.size;
        this.set = function (coord, value) {
            _this.map.set(_this.getCoordKey(coord), value);
            _this.size = _this.map.size;
            return _this;
        };
        this.get = function (coord) {
            return _this.map.get(_this.getCoordKey(coord));
        };
        this.has = function (coord) {
            return _this.map.has(_this.getCoordKey(coord));
        };
        this["delete"] = function (coord) {
            var success = _this.map["delete"](_this.getCoordKey(coord));
            if (success) {
                _this.size = _this.map.size;
            }
            return success;
        };
    }
    return CoordMap;
}());
export { CoordMap };
//# sourceMappingURL=CoordMap.js.map